module.exports = __webpack_public_path__ + "img/infrastructure-2.b1c3af86.png";